<template>
    <div>
        <form autocomplete="off">
            <div class="grid md:grid-cols-2 gap-3">
                <k-input
                    class="mb-4"
                    id="firstName"
                    label="First name"
                    v-model="form.firstName"
                    :field-errors="validation.fieldErrors"/>
                <k-input
                    class="mb-4"
                    id="lastName"
                    label="Last name"
                    v-model="form.lastName"
                    :field-errors="validation.fieldErrors"/>
            </div>
            <div class="mb-4">
                <label class="block text-gray-700 text-sm font-bold mb-2" for="mobilePhone">
                    {{ $t("mobilePhone") }}
                </label>
                <vue-tel-input v-model="form.mobilePhone"
                               :validCharactersOnly="true"
                               inputClasses="appearance-none block w-full bg-gray-200 border-gray-200 text-gray-700 border rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                               :enabledCountryCode="false"
                               inputId="mobilePhone"
                               mode="international"
                               :preferredCountries="['SG']"
                               placeholder=""
                               :wrapperClasses="['appearance-none block w-full bg-gray-200 text-gray-700 border rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500', fieldError('mobilePhone') ? 'border-red-500!': 'border-gray-200']">

                </vue-tel-input>
                <div v-if="fieldError('mobilePhone')"
                     class="text-red-500 text-xs italic">
                    {{ fieldError('mobilePhone') }}
                </div>
            </div>
            <k-input
                class="mb-4"
                id="email"
                label="Email"
                v-model="form.email"
                :field-errors="validation.fieldErrors"
                type="email"/>
            <div class="grid md:grid-cols-2 gap-3" v-if="!hidePassword">
                <k-input
                    class="mb-4"
                    id="password"
                    label="Password"
                    v-model="form.password"
                    :field-errors="validation.fieldErrors"
                    type="password"/>
                <k-input
                    class="mb-4"
                    id="passwordRepeat"
                    label="Confirm password"
                    v-model="form.passwordRepeat"
                    :field-errors="validation.fieldErrors"
                    type="password"/>
            </div>
            <div class="grid md:grid-cols-2 gap-3">
                <k-input
                    class="mb-4"
                    id="referralCode"
                    label="Referral code"
                    v-model="form.referralCode"
                    :field-errors="validation.fieldErrors"/>
            </div>
            <div>
                <a-checkbox
                    class="mb-4"
                    id="acceptTermsOfUse"
                    v-model="form.acceptTermsOfUse"
                >{{ $t("iAccept") }}
                </a-checkbox>
                <a href="https://assets.website-files.com/61c1fc0c4b29a848ee7d2928/633149af2ffcde097e5b8fba_20220815_Terms%20of%20Use.pdf"
                   target="_blank"
                   class="text-primary-500">{{ $t("terms") }}</a>
                <div v-if="validation.fieldErrors['acceptTermsOfUse']" class="text-red-500 text-xs italic">
                    {{ validation.fieldErrors['acceptTermsOfUse'] }}
                </div>
            </div>
            <div>
                <a-checkbox
                    class="mb-4"
                    id="acceptPrivacyPolicy"
                    v-model="form.acceptPrivacyPolicy">
                    {{ $t("iAccept") }}
                </a-checkbox>
                <a href="https://www.kilde.sg/privacy"
                   target="_blank"
                   class="text-primary-500">{{ $t("privacyPolicy") }}</a>
                <div v-if="validation.fieldErrors['acceptPrivacyPolicy']" class="text-red-500 text-xs italic">
                    {{ validation.fieldErrors['acceptPrivacyPolicy'] }}
                </div>
            </div>
            <div class="mt-6">
                <k-button @click.native.prevent="onSubmit">
                    {{ $t("createAccount") }}
                </k-button>
            </div>
        </form>
    </div>
</template>

<script>

import {VueTelInput} from 'vue-tel-input';

export default {
    components: {
        VueTelInput,
    },
    props: {
        validation: {
            type: Object,
            required: true
        },
        hidePassword: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            landingUrl: process.env.VUE_APP_KILDE_LENDING_BASE_URL,
            form: {
                firstName: null,
                lastName: null,
                email: null,
                password: null,
                passwordRepeat: null,
                acceptTermsOfUse: null,
                acceptPrivacyPolicy: null,
                referralCode: null
            }
        }
    },
    async mounted() {
        if (this.$route.query.email) {
            this.form.email = this.$route.query.email
            this.$identify({email: this.form.email});
        }
        if (!this.$isProd) {
            try {
                const {data} = await this.$http.get('/api/investor/public/fake-sign-up', {});
                this.form = data;
            } catch (e) {
                console.error(e)
            }
        }
        if (this.$route.query.refcode) {
            this.form.referralCode = this.$route.query.refcode
        }
    },
    methods: {
        async onSubmit() {
            this.$emit('submit', this.form);
        },
        fieldError(field) {
            return this.validation.fieldErrors[field];
        },
    }
}
</script>

<style>
.vue-tel-input {
    border: unset !important;
}
</style>

